import type { InitOptions } from "i18next";

export const i18nextConfig: InitOptions = {
  debug: false,
  fallbackLng: "en",
  supportedLngs: ["en", "nl", "de", "da", "fr", "it", "pl", "cs"],
  ns: ["common"],
  defaultNS: "common",
  fallbackNS: "common",
  interpolation: {
    escapeValue: false,
  },
  detection: {
    order: ["localStorage", "navigator"],
    lookupLocalStorage: "i18nextLng",
    caches: ["localStorage"],
  },
};